import React, { useState } from "react";
import "./Explore_Category_Card.css";
import { useNavigate } from "react-router-dom";
import Alert_Modal from "../../../common_components/common_modal/alert_modal/Alert_Modal";
import { Button } from "react-bootstrap";

const Explore_Category_Card = (props) => {
  const navigate = useNavigate();
  // const [showModal, setShowModal] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  const handleCategoryClick = () => {
    // if (props?.data?.eight_plus_status) {
    //   // Show modal if eight_plus_status is true
    //   setModalShow(true);
    // } else {
    // Directly navigate if not
    navigate(
      `/product-listing/${props?.id}?category_name=${encodeURIComponent(
        props?.product
      )}&category_image=${encodeURIComponent(props?.img)}`
    );
    // }
  };

  return (
    <section className="Explore_Category_Card">
      <div>
        <div className={`img_holder`} onClick={handleCategoryClick}>
          <img
            src={process.env.REACT_APP_IMG_URL + props?.img}
            className="product_img"
          />
          {/* {console.log(process.env.REACT_APP_IMG_URL + props?.img) */}
        </div>

        <div className="text_holder" onClick={handleCategoryClick}>
          <h6>{props?.product}</h6>
          <ul>
            {props?.data?.p_sub_categories?.slice(0, 4)?.map((val) => (
              <li key={val?.id}>{val?.name}</li>
            ))}

            {/* <li>MCB</li>

            <li>Switch boards & Buttons Wires</li>

            <li>Wires</li> */}
          </ul>
        </div>

        <div className="btn_holder">
          <Button className="shop_btn" onClick={handleCategoryClick}>
            Shop Now
          </Button>
        </div>

        <Alert_Modal
          data={props?.data}
          url={`/product-listing/${
            props?.id
          }?category_name=${encodeURIComponent(
            props?.product
          )}&category_image=${encodeURIComponent(props?.img)}`}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </div>
    </section>
  );
};

export default Explore_Category_Card;
